import React from 'react';
import { Form } from 'semantic-ui-react';
import { FieldTypePropType } from '../../services/proptypes';
import EmailField from '../Fields/EmailField';
import PhoneNumberField from '../Fields/PhoneNumberField';
import './CustomerInformationForm.css';
var defaultProps = {
  email: {
    name: 'email',
    defaultValue: '',
    onChange: null,
    value: undefined,
    required: true
  },
  phoneNumber: {
    name: 'phoneNumber',
    defaultValue: '',
    onChange: null,
    value: undefined,
    required: true
  },
  firstName: {
    name: 'firstName',
    defaultValue: '',
    onChange: null,
    value: undefined,
    required: true
  },
  lastName: {
    name: 'lastName',
    defaultValue: '',
    onChange: null,
    value: undefined,
    required: true
  },
  onChange: null
};
function CustomerInformationForm(_ref) {
  var email = _ref.email,
    phoneNumber = _ref.phoneNumber,
    onChange = _ref.onChange,
    firstName = _ref.firstName,
    lastName = _ref.lastName;
  var emailName = email.name,
    emailOnChange = email.onChange,
    emailDefaultValue = email.defaultValue,
    emailValue = email.value,
    emailRequired = email.required;
  var phoneNumberName = phoneNumber.name,
    phoneNumberOnChange = phoneNumber.onChange,
    phoneNumberDefaultValue = phoneNumber.defaultValue,
    phoneNumberValue = phoneNumber.value,
    phoneNumberRequired = phoneNumber.required;
  var firstNameName = firstName.name,
    firstNameOnChange = firstName.onChange,
    firstNameDefaultValue = firstName.defaultValue,
    firstNameValue = firstName.value,
    firstNameRequired = firstName.required;
  var lastNameName = lastName.name,
    lastNameOnChange = lastName.onChange,
    lastNameDefaultValue = lastName.defaultValue,
    lastNameValue = lastName.value,
    lastNameRequired = lastName.required;
  return /*#__PURE__*/React.createElement(Form, {
    className: "customer-information-form"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    widths: "equal"
  }, /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Form.Input, {
    label: "First Name",
    value: firstNameValue,
    name: firstNameName || 'firstName',
    onChange: firstNameOnChange || onChange,
    defaultValue: firstNameDefaultValue,
    required: firstNameRequired,
    fluid: true
  })), /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Form.Input, {
    required: lastNameRequired,
    label: "Last Name",
    value: lastNameValue,
    name: lastNameName || 'lastName',
    onChange: lastNameOnChange || onChange,
    defaultValue: lastNameDefaultValue,
    fluid: true
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    widths: "equal"
  }, /*#__PURE__*/React.createElement(EmailField, {
    name: emailName,
    onChange: emailOnChange || onChange,
    defaultValue: emailDefaultValue,
    value: emailValue,
    required: emailRequired
  }), /*#__PURE__*/React.createElement(PhoneNumberField, {
    name: phoneNumberName,
    defaultValue: phoneNumberDefaultValue,
    onChange: phoneNumberOnChange || onChange,
    value: phoneNumberValue,
    required: phoneNumberRequired
  })));
}
CustomerInformationForm.defaultProps = defaultProps;
export default CustomerInformationForm;